

angular.module('storyApp').factory('storiesFilterService' , ['storyEvents', function(storyEvents){
  "use strict";

  var win = window, // "window" object
  doc = document; // "document" object

  var proto = {
    // filter current list of stories using already rendered stories
    filterCurrentStories : function(filterCount,itemsToDisplay){
      var that = this;
      this.settings = this.settings || { itemsToDisplay:3,filterCount:17 };

      var maxCount = filterCount || this.settings.filterCount || 17;
      var toDisplay = itemsToDisplay || this.settings.itemsToDisplay || 3;
      var renderedStories = that.getRenderedStories(true);
      var allStories = that.getAllStories();

      if(renderedStories.length > 0) {

        var aLen = allStories.length;
        var rLen = renderedStories.length;

        if(rLen > 0 && rLen < maxCount){
          // console.log("filterCurrentStories - condition 1");
          // -- covers the following 3 items displayable --
          var filtered = allStories.filter(function(story){
            var result = false;
            for(var i=0;i<rLen;i++){
              if(story.url === renderedStories[i].url){
                result = true;
                break;
              }
            }
            return !result;

          });
          return filtered;

        } else if (rLen == maxCount || rLen === 0){
          // console.log("filterCurrentStories - condition 2");
          // -- covers the First/Last EXACT 3 items displayable --
          var displayedItems = (rLen == maxCount) ? allStories.splice(maxCount,toDisplay) : allStories.splice(0,toDisplay); // logic to return the first items of the list

          return displayedItems;

        } else {
          // console.log("filterCurrentStories - condition 3");
          // -- covers the Last REMAINING items displayable --
          var remaining = aLen - rLen;
          var firstDisplayed = allStories.splice(0,remaining);
          var remainingItems = allStories.splice((aLen-remaining),remaining);

          return firstDisplayed.concat(remainingItems);
        }
      } else {
        // return list of stories if storage is empty
        return allStories;
      }
    },
    // set expiration date (optional: set number of days)
    setExpireDate : function(daysToExpire){
      var days = daysToExpire || 7;
      var today = new Date().getTime();
      var toMilliseconds = 86400000;

      return (today + (days * toMilliseconds));
    },
    // array comparer http://stackoverflow.com/questions/1988349/array-push-if-does-not-exist
    checkItemInArray : function (arr,comparer) {
      for(var i=0; i < arr.length; i++) {
        if(comparer(arr[i])) return true;
      }
      return false;
    },
    // based on "checkItemInArray", add new item to array. return flag if a new item was added
    addNewToArray : function (element,arr,comparer) {
      var that = this,
      foundNew = false;
      if (!that.checkItemInArray(arr,comparer)) {
        arr.push(element);
        foundNew = true;
      }
      return foundNew;
    }
  };
  var obj = Object.create(proto);

  obj.init = function(opts){

    // EVENT BIND : addOnChange - store rendered story to localStorage
    storyEvents.addOnChange(function(storyIndex,metadata){
      if(storyIndex > 1) {
        this.storeRenderedStory(metadata.meta);
      }
    }.bind(this));

    return this;

  };
  // store all API-retrieved stories for use (optional: store all to sessionStorage ** INCOMPLETE **)
  obj.storeAllStories = function(allStories,enableSessionStorage){
    var that = this;

    allStories = allStories.sort(function(a,b){
      return new Date(b.pudate).getTime() - new Date(a.pudate).getTime();
    });

    var filtered = allStories.filter(function(story){
      return story.url !== '';
    });

    if(typeof enableSessionStorage === 'boolean' && enableSessionStorage) {
      win.sessionStorage.setItem('allStories',JSON.stringify(filtered));
    } else {
      that.allStories = allStories;
    }

    return filtered;
  };
  obj.storeRenderedStory = function(renderedStory,daysToExpire,filterCount){
    var that = this;
    that.settings = that.settings || { daysToExpire:7, filterCount:17 };

    var maxCount = filterCount || that.settings.filterCount || 17;
    var ToExpire = daysToExpire || that.settings.daysToExpire || 7;

    var renderedStories = obj.getRenderedStories();
    var rsLen = (renderedStories.length - 1 < 0) ? 0 : renderedStories.length - 1;

    var stampObj = {
      creationDate: new Date().getTime(),
      expireDate: that.setExpireDate(ToExpire)
    };

    // create/reset storage
    if (rsLen === 0) {
      // create new storage
      renderedStories.push(stampObj);
    } else {
      // reset storage (storage expired)
      if (renderedStories[0].expireDate <= new Date().getTime()) {
        win.localStorage.removeItem('renderedStories');
        renderedStories = [stampObj];
      } else if (rsLen > maxCount) {
        // reset storage (storage exceeded maximum count)
        var shifted = renderedStories.shift();
        renderedStories = [shifted];
      }
    }

    var foundNewItem = false; // flag to skip storing when existing stories being stored
    // check if single or array of stories being stored
    if(renderedStory instanceof Array){
      // verify and store each read/rendered story within array
      renderedStory.forEach(function(story){
        foundNewItem = that.addNewToArray(story,renderedStories,function(item){
          return item.url === story.url;
        });
      });
    } else {
      // verify and store read/rendered story
      foundNewItem = that.addNewToArray(renderedStory,renderedStories,function(item){
        return item.url === renderedStory.url;
      });
    }
    // if a new item was added, set new array to localStorage
    if (foundNewItem) {
      win.localStorage.setItem('renderedStories',JSON.stringify(renderedStories));
    }

    return renderedStory;
  };
  // retrieve stored rendered stories (optional: exclude timestamp from returned value)
  obj.getRenderedStories = function(excludeTimestamp){
    var result = (win.localStorage.getItem('renderedStories') !== null) ? JSON.parse(win.localStorage.getItem('renderedStories')) : [];
    // retrieve stored rendered stories
    if(excludeTimestamp && result.length > 0) var shifted = result.shift();

    return result;
  };
  obj.getAllStories = function(){
    var that = this;

    if(win.sessionStorage.getItem('allStories') !== null) {
      return JSON.parse(win.sessionStorage.getItem('allStories'));

    } else if (typeof that.allStories !== 'undefined') {
      if(that.allStories.length > 0) return that.allStories;
      else return [];

    } else return [];
  };
  obj.getCurrentStories = function(itemsToDisplay,allStories){
    var that = this;
    that.settings = that.settings || {itemsToDisplay:3};
    var toDisplay = (itemsToDisplay === 0) ? 0 : itemsToDisplay || that.settings.itemsToDisplay || 3;
    var allCurrentStories = that.filterCurrentStories();
    // from 'http://stackoverflow.com/questions/7158654/how-to-get-random-elements-from-an-array'
    // get any story in a random order
    function getRandomStory(){
      var story = allCurrentStories.slice(0),
      i = allCurrentStories.length,
      min = i - toDisplay,
      temp, index;
      while (i-- > min) {
        index = Math.floor((i + 1) * Math.random());
        temp = story[index];
        story[index] = story[i];
        story[i] = temp;
      }
      if(typeof story.slice(min).storageDate === 'undefined') { // check if returned entry was the storage timestamp
      return story.slice(min);
    } else {
      return story.slice(min + 1);
    }
  }
  var stories = null;
  if(typeof toDisplay === 'string') {
    if(toDisplay === 'all'){
      stories = allCurrentStories;
    } else {
      stories = getRandomStory();
    }
  } else if (toDisplay <= allCurrentStories.length && toDisplay > 0){
    stories = getRandomStory();
  } else {
    stories = that.getAllStories();
  }
  return stories;

};
obj.getFilteredStories = function(){
  return this.filterCurrentStories();

};
obj.verifyApiURLStoryCount = function(url) {
  var rsLen = obj.getRenderedStories(true).length;
  var fromReplace = new RegExp("num=3");
  var toReplace = '';

  if(rsLen > 0 && rsLen < 20) {
    toReplace = "num=" + (rsLen+3);
    return url.replace(fromReplace,toReplace);
  } else if (rsLen >= 20){
    toReplace = "num=20";
    return url.replace(fromReplace,toReplace);
  } else {
    return url;
  }


};

obj.init();

return obj;

}]);



// WEBPACK FOOTER //
// ./assets/components/threethings/factories/storiesFilterService.js